import { render, staticRenderFns } from "./TdEx.vue?vue&type=template&id=75c37e9d&scoped=true&"
import script from "./TdEx.vue?vue&type=script&lang=js&"
export * from "./TdEx.vue?vue&type=script&lang=js&"
import style0 from "./TdEx.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./TdEx.vue?vue&type=style&index=1&id=75c37e9d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c37e9d",
  null
  
)

export default component.exports